import { render, staticRenderFns } from "./settingFreshDistribution.vue?vue&type=template&id=c84bd4b6"
import script from "./settingFreshDistribution.vue?vue&type=script&lang=js"
export * from "./settingFreshDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports